import styled from 'styled-components';

export const YoutubeVideoGrid = styled.section`
  display: grid;
  grid-template-columns: ${(props) =>
    props.stroller || props.homeVideo ? '100% 0%' : '50% 45%'};
  justify-content: space-between;
  margin: ${(props) => (props.stroller ? '0' : '20px 0')};
  padding: ${(props) =>
    props.catPage
      ? '0'
      : props.homeVideo
        ? '0 4px'
        : props.stroller
          ? '20px 3.5%'
          : props.padding
            ? '20px 7.5%'
            : '0 7.5%'};
  background: linear-gradient(
    to bottom,
    ${(props) => props.sectionBgColorStart},
    ${(props) => props.sectionBgColorEnd}
  );

  @media (max-width: 720px) {
    grid-template-columns: 100%;
    padding: ${(props) =>
      props.catPage ? '0' : props.padding ? '20px 10px' : '0 10px'};
    margin: ${(props) => (props.stroller || props.homeVideo ? '0' : '30px 0')};
  }
`;

export const YoutubeVideoCTA = styled.button`
  border: none;
  font-size: clamp(14px, 2vw, 16px);
  font-weight: 600;
  letter-spacing: 1.8px;
  outline: none;
  background: transparent;
  color: hsl(0deg, 0%, 0%, 87%);
  text-transform: uppercase;
  padding: 0;
  font-family: 'Montserrat';
  display: flex;
  align-items: center;
  @media (min-width: 720px) {
    cursor: pointer;
  }

  img {
    width: clamp(18px, 3vw, 22px);
    height: clamp(18px, 3vw, 22px);
    opacity: 0.8;
  }
`;
